export interface BlogSectionModel {
  text?: string;
  sectionTitle?: string;
  image?: string;
  imageDescription?: string;
  centeredText?: string;
}

export const BLOG_LANGUAGES = ['pl', 'uk', 'en', 'fr', 'bg', 'vi'] as const;

export type BlogLanguage = (typeof BLOG_LANGUAGES)[number];

export interface BlogArticleTranslation {
  title?: string;
  introduction?: string;
  text?: Array<Partial<BlogSectionModel>>;
  sources?: string[];
}

export interface BlogArticleModel {
  title: string;
  introduction: string;
  text: BlogSectionModel[];
  date: Date;
  image: string;
  url: string;
  sources?: string[];
  translations?: Partial<Record<BlogLanguage, BlogArticleTranslation>>;
}
